// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ECAS","requiredAsterisk":"Info_requiredAsterisk__1tBHX"};